import { endOfDay, format, formatISO, fromUnixTime, getUnixTime, parseISO, startOfDay } from 'date-fns';
import { zonedTimeToUtc, utcToZonedTime } from 'date-fns-tz';

export const DISPLAY_DATE_FORMAT = 'yyyy-MM-dd';
export const DISPLAY_DATE_FORMAT_PICKER = 'YYYY-MM-DD';
export const DISPLAY_DATE_TIME_FORMAT = 'yyyy-MM-dd HH:mm';
export const DISPLAY_DATE_TIME_FILENAME_FORMAT = 'yyyy-MM-dd HH:mm:ss';

export const convertISOStringToDate = (date: string): Date => {
  return parseISO(date);
};

export const convertDateToISOString = (date: Date): string => {
  return formatISO(date);
};

export const convertDateToString = (date: Date, customFormat = DISPLAY_DATE_FORMAT): string => {
  return format(date, customFormat);
};

const getUserTimezone = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

export const convertDateToStringIgnoringTimezone = (date: Date): string => {
  const timezone = getUserTimezone();
  return zonedTimeToUtc(date, timezone).toISOString();
};

export const convertUtcStringToLocalTimezoneString = (
  date: string | undefined,
  customFormat = DISPLAY_DATE_FORMAT,
): string | undefined => {
  if (!date) return undefined;
  const timezone = getUserTimezone();
  const zonedDate = utcToZonedTime(date, timezone);
  return format(zonedDate, customFormat);
};

export const convertUtcDateToTimezoneString = (date?: Date, customFormat = DISPLAY_DATE_FORMAT): string | undefined => {
  if (!date) return undefined;
  const zonedDate = utcToZonedTime(date, 'GMT');
  return format(zonedDate, customFormat);
};

export const convertISOStringToLocalDateString = (date: string, customFormat = DISPLAY_DATE_FORMAT): string => {
  return convertDateToString(convertISOStringToDate(date), customFormat);
};

export const convertDateToDayStart = (date: Date): string => {
  return convertDateToString(startOfDay(date));
};

export const convertDateToDayEnd = (date: Date): string => {
  return convertDateToString(endOfDay(date));
};

export const convertEpochToDate = (epoch: number): Date => {
  return fromUnixTime(epoch);
};

export const convertDateToUnix = (date: Date): number => {
  return getUnixTime(date);
};
